<template>
    <div class="setting-alliance">
        <div class="page-title">商业联盟设置</div>

        <div>
            <pay-box title="联盟信息基础设置">
                <div class="info-box">
                    <div class="info-row">
                        <div class="label">商业联盟名称</div>
                        <at-input v-model="name" :maxLength="20" placeholder="请输入" class="full-with" @blur="nameBlur">
                            <div class="num">{{ (name || '').length }}/20</div>
                        </at-input>
                    </div>
                    <div class="info-row">
                        <div class="label">联盟头像上传</div>
                        <div class="uploader-container">
                            <div class="uploader">
                                <upload-image v-model="avatar_url" usage="alliance-avatar" @change="avatarChange" />
                            </div>
                            <div class="tips">
                                <div>图片格式必须为:png,jpeg,jpg;不可大于1M;</div>
                                <div>建议使用png格式图片，以保持最佳效果;建议图片尺寸为600px*600px</div>
                            </div>
                        </div>

                    </div>
                    <div class="info-row">
                        <div class="label">商业联盟介绍</div>
                        <div class="uploader-container">
                            <div class="uploader">
                                <upload-image v-model="summary_image_url" usage="alliance-summary" @change="summaryChange" />
                            </div>
                            <div class="tips">
                                <div>图片格式必须为:png,jpeg,jpg;不可大于1M;</div>
                                <div>建议使用png格式图片，以保持最佳效果;建议图片尺寸为600px*600px</div>
                            </div>
                        </div>
                    </div>
                    <div class="info-row">
                        <div class="label">自定义宣传图</div>
                        <div class="uploader-container">
                            <div class="uploader">
                                <upload-image v-model="promotion_image_url" usage="alliance-promotion" @change="promotionChange" />
                            </div>
                            <div class="tips">
                                <div>图片格式必须为:png,jpeg,jpg;不可大于1M;</div>
                                <div>建议使用png格式图片，以保持最佳效果;建议图片尺寸为600px*600px</div>
                            </div>
                        </div>
                    </div>
                </div>
            </pay-box>

            <!-- <pay-box title="子小程序初始资源设置">
                <div class="input-row">
                    <div class="info-row">
                        <div class="label">
                            <span>AI检测次数</span>
                        </div>
                        <at-input v-model="initial_count" class="full-with"></at-input>
                    </div>
                    <div class="info-row">
                        <div class="label">
                            <span>报告印刷份数</span>
                        </div>
                        <at-input v-model="print_count" class="full-with"></at-input>
                    </div>
                    <div class="info-row">
                        <div class="label">
                            <span>AI Token数量</span>
                        </div>
                        <at-input v-model="token_count" class="full-with"></at-input>
                    </div>
                </div>
            </pay-box> -->

            <pay-box title="子小程序分销设置" padding="16px 0 24px">

                <div style="display: flex; justify-content: space-between;padding: 0 24px;">
                    <div class="tabs-box">
                        <div class="tabs" :class="{ active: tab.group == serviceGroup }" v-for="tab in modules"
                            :key="tab.group" @click="tabClick(tab.group)">{{ tab.title }}</div>
                    </div>

                    <div class="add-btn" @click="selectShow = true">
                        <img src="/assets/images/card-template/card-template-icon1.png" />
                        <span>前往绑定</span>
                    </div>
                </div>

                <div class="line"></div>

                <div class="item-box">
                    <template v-for="item in selectList">
                        <div class="item" :key="item.id" v-if="item.group == serviceGroup">

                            <div class="del" @click="delItem(item.id)">
                                <img src="/assets/images/alliance-del-icon.png" />
                            </div>

                            <div class="item-info">
                                <div class="price" v-if="item.pay_amount">¥{{ item.pay_amount }}</div>
                                <div class="price" v-else>0.00</div>
                                <div class="thumb">
                                    <img :src="item.thumb" />
                                </div>
                                <div class="info">
                                    <div class="label">
                                        <span v-if="serviceGroup == 'serve'">服务标题</span>
                                        <span v-if="serviceGroup == 'courses'">课程标题</span>
                                        <span v-if="serviceGroup == 'activity'">活动标题</span>
                                    </div>
                                    <div class="content">{{ item.title }}</div>
                                    <div class="label">
                                        <span v-if="serviceGroup == 'serve'">服务介绍</span>
                                        <span v-if="serviceGroup == 'courses'">课程介绍</span>
                                        <span v-if="serviceGroup == 'activity'">活动介绍</span>
                                    </div>
                                    <div class="content summary">{{ item.summary }}</div>
                                </div>
                            </div>
                            <div class="shareing">
                                <div class="shareing-item">
                                    <div class="name">一级分销</div>
                                    <div class="input">
                                        <input type="text" v-model="item.l1" @blur="calcResult(item)">
                                    </div>
                                    <div class="symbol">%</div>
                                    <div class="result" v-if="item.price && Number(item.l1)">
                                        <span>*{{ item.pay_amount }}=</span>
                                        <span>{{ (item.pay_amount * item.l1 / 100).toFixed(2) }}</span>
                                    </div>
                                </div>
                                <div class="shareing-item">
                                    <div class="name">二级分销</div>
                                    <div class="input">
                                        <input type="text" v-model="item.l2" @blur="calcResult(item)">
                                    </div>
                                    <div class="symbol">%</div>
                                    <div class="result" v-if="item.price && Number(item.l2)">
                                        <span>*{{ item.pay_amount }}=</span>
                                        <span>{{ (item.pay_amount * item.l2 / 100).toFixed(2) }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    
                    <div class="empty" v-if="showEmpty">
                        <img src="/assets/images/empty-icon.png" />
                        <span>暂无绑定</span>
                    </div>
                </div>
                

            </pay-box>
        </div>

        <template v-if="selectShow">
            <SelectService :selects="selectList" :group="serviceGroup" @confirm="confirmSelect" @closePop="selectShow = false"></SelectService>
        </template>
        
        <a-modal v-model="showDel" title="提示" centered @ok="delConfirm()">
            <p>确定要删除吗？</p>
        </a-modal>
    </div>

</template>

<script>
import PayBox from "@/views/AST/Pay/Step/PayBox.vue";
import AtInput from "@/components/AtInput.vue";
import UploadImage from "@/components/UploadImage.vue";
import SelectService from "./components/selectService.vue";
import api from "@/repo/api";

export default {
    name: "SettingAlliance",
    components: { PayBox, AtInput, UploadImage, SelectService },
    data() {
        return {
            showDel: false,
            selectShow: false,
            serviceGroup: 'serve',
            selectList: [],
            modules: [
                {
                    title: '服务',
                    group: 'serve',
                },
                {
                    title: '课程',
                    group: 'courses',
                },
                {
                    title: '活动',
                    group: 'activity',
                },
            ],
            name: '',
            avatar_url: '',
            summary_image_url: '',
            promotion_image_url: '',
            initial_count: '',
            print_count: '',
            token_count: '',
            info: {},
            delId: '',
        }
    },
    computed: {
        serveList() {
            return (this.selectList || []).filter(item => item.group === 'serve');
        },
        courseList() {
            return (this.selectList || []).filter(item => item.group === 'courses');
        },
        activityList() {
            return (this.selectList || []).filter(item => item.group === 'activity');
        },
        selectIds() {
            return (this.selectList || []).map(item => item.id);
        },
        showEmpty() {
            let flag = false;
            if (this.serviceGroup === 'serve') {
                flag = this.serveList.length == 0;
            } 

            if (this.serviceGroup === 'courses') {
                flag = this.courseList.length == 0;
            } 

            if (this.serviceGroup === 'activity') {
                flag = this.activityList.length == 0;
            }

            return flag;
        },
    },
    mounted() {
        this.getInfo();
        this.getShareInfo();
    },
    methods: {
        calcResult(item) {
            // 1. 预处理：如果为空字符串、null或undefined，则视为0；否则转为数字
            const l1 = (item.l1 === '' || item.l1 === null || item.l1 === undefined) ? 0 : Number(item.l1);
            const l2 = (item.l2 === '' || item.l2 === null || item.l2 === undefined) ? 0 : Number(item.l2);
            
            // 2. 校验：检查转换后是否为有效数字 (防止输入 'abc' 等非数字字符)
            if (isNaN(l1) || isNaN(l2)) {
                this.$message.error('请输入正确的数字');
                return;
            }
            
            // 3. 校验：总和不能超过30
            if (l1 + l2 > 30) {
                this.$message.error('一级分销+二级分销不能超过30%');
                return;
            }
            
            // 4. 提交：使用处理后的 l1 和 l2 (保证是数字类型)
            api.post('/ale-alliance/update-share-course', {
                course_id: item.id,
                l1: l1,
                l2: l2,
            }, (res) => {
                this.$message.data(res)
            })
        },
        delItem(id) {
            console.log(id);
            this.delId = id;
            this.showDel = true;
        },
        delConfirm() {
            this.showDel = false;
            if (!this.delId) return;
            api.post('/ale-alliance/remove-share-course', {
                course_id: this.delId,
            }, (res) => {
                if (res.code == 0) {
                    this.$message.success('删除成功');
                    this.getShareInfo();
                }else{
                    this.$message.error(res.msg);
                }
            })
        },
        confirmSelect({group, list}) {

            let course_ids = list.map(item => item.id);
            this.serviceGroup = group;
            api.post('/ale-alliance/sync-share-course', {
                group,
                course_ids,
            }, (res) => {
                if (res.code != 0) {
                    this.$message.error(res.msg);
                }
            })
        },
        tabClick(group) {
            this.serviceGroup = group;
            this.getShareInfo();
        },
        getInfo() {
            api.get('/ale-alliance/info', (res) => {
                if (res.code == 0) {
                    this.info = res.data;
                    this.name = res.data.name;
                    this.avatar_url = res.data.avatar_url;
                    this.summary_image_url = res.data.summary_image_url;
                    this.promotion_image_url = res.data.promotion_image_url;
                }
            })
        },
        getShareInfo() {
            api.get('/ale-alliance/share-courses',{group: this.serviceGroup}, (res) => {
                if (res.code == 0) {
                    this.selectList = res.data;
                }
            })
        },
        nameBlur(value) {
            if (!value) return;
            api.post('/ale-alliance/update-name', {
                name: value,
            }, (res) => {
                if (res.code != 0) {
                    this.$message.error(res.msg);
                }
            })
        },
        avatarChange(value) {
            if (!value) return;
            api.post('/ale-alliance/update-avatar', {
                avatar_url: value,
            }, (res) => {
                if (res.code != 0) {
                    this.$message.error(res.msg);
                }
            })
        },
        summaryChange(value) {
            if (!value) return;
            api.post('/ale-alliance/update-summary-image', {
                summary_image_url: value,
            }, (res) => {
                if (res.code != 0) {
                    this.$message.error(res.msg);
                }
            })
        },
        promotionChange(value) {
            if (!value) return;
            api.post('/ale-alliance/update-promotion-image', {
                promotion_image_url: value,
            }, (res) => {
                if (res.code != 0) {
                    this.$message.error(res.msg);
                }
            })
        },
    }
}
</script>

<style scoped lang="less">
.level-item {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;

    .level-name {
        color: #333333;
        font-size: 14px;
    }
}


.tabs-box {
    display: flex;
    align-items: center;

    .tabs {
        width: 92px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        background: #FFFFFF;
        border: 1px solid #EEEEEE;
        margin-right: 16px;
        cursor: pointer;
    }

    .active {
        color: #fff;
        background: #333333;
        border: 1px solid #333333;
    }
}

.setting-alliance {
    padding-bottom: 50px;
}

.info-box {
    width: 100%;
}

.input-row {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 32px;

    .full-with {
        width: 120px !important;
    }

    .info-row {
        width: fit-content;
        display: flex;
        align-items: center;
        margin: 0;

        &:last-child {
            margin-bottom: 0;
        }

        .num {
            color: rgba(0, 0, 0, 0.25);
            line-height: 40px;
            padding: 0 12px;
        }

        .label {
            font-size: 14px;
            color: #333333;
            margin-right: 16px;
        }
    }
}


.op-box {
    width: 70px;
    display: flex;
    justify-content: space-between;

    .op-item {
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        img {
            width: 100%;
            height: 100%;
        }
    }
}

.add-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FBB03B;
    font-size: 14px;
    
    cursor: pointer;

    img {
        width: 16px;
        height: 16px;
        margin-right: 4px;
    }
}

.line{
    width: 100%;
    height: 1px;
    background: #EEEEEE;
    margin: 16px auto;
}

.item-box{
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
    padding: 0 24px;
    .item{
        width: 472px;
        height: 236px;
        background: #FFFFFF;
        border: 1px solid #EEEEEE;
        padding: 24px;
        box-sizing: border-box;
        position: relative;
        .del{
            width: 24px;
            height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            position: absolute;
            top: 24px;
            right: 24px;
            z-index: 100;
            img{
                width: 100%;
                height: 100%;
                cursor: pointer;
            }
        }
        .item-info{
            display: flex;
            align-items: center;
            gap: 16px;
            position: relative;
            .price{
                height: 24px;
                line-height: 24px;
                text-align: center;
                background: #FFAD00;
                font-size: 14px;
                color: #FFFFFF;
                padding: 0 12px;
                position: absolute;
                top: 4px;
                left: -20px;
            }
            .thumb{
                width: 132px;
                height: 132px;
                img{
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
            .info{
                flex: 1;
                height: 132px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .label{
                    color: #999999;
                    font-size: 14px;
                }
                .summary{
                    height: 48px;
                }
                .content{
                    color: #333333;
                    font-size: 16px;
                    font-weight: bold;
                    // 超出2行省略
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
            }
        }
        .shareing{
            display: flex;
            align-items: center;
            gap: 20px;
            margin-top: 24px;
            .shareing-item{
                width: 50%;
                display: flex;
                align-items: center;
                .name{
                    // width: 30px;
                    font-size: 14px;
                    color: #333333;
                }
                .input{
                    width: 48px;
                    height: 40px;
                    margin-left: 8px;
                    margin-right: 4px;
                    border: 1px solid #EEEEEE;

                    input{
                        width: 100%;
                        height: 100%;
                        text-align: center;
                        border-radius: 0;
                        box-sizing: border-box;
                        outline: none;
                        border: none;
                    }
                }
                .symbol{
                    font-size: 12px;
                    color: #333333;
                }
                .result{
                    font-size: 12px;
                    span{
                        &:nth-child(1){
                            color: #999999;
                        }
                        &:nth-child(2){
                            color: #FFAD00;
                        }
                    }
                }
            }
        }
    }
    .empty{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 56px 0;
        margin: 0 auto;
        img{
            width: 120px;
            height: 120px;
        }
        span{
            font-size: 14px;
            color: rgba(0,0,0,0.1);
            margin-top: 24px;
        }
    }
}

.info-row {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 32px;

    &:last-child {
        margin-bottom: 0;
    }

    .label {
        width: 96px;
        font-size: 14px;
        color: #333333;
        margin-right: 16px;
    }

    .num {
        color: rgba(0, 0, 0, 0.25);
        line-height: 40px;
        padding: 0 12px;
    }
}

.uploader-container {
    .tips {
        font-size: 12px;
        color: #999999;
    }
}
</style>